import { Button, Modal } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";

const AddPlayerToRosterModal = ({ disabled, children }) => {
  const [open, setOpen] = useState(false);

  const { formatMessage } = useIntl();

  return (
    <>
      <Button onClick={() => setOpen(true)} type="primary" icon={<i className="fas fa-plus" />} disabled={disabled}>
        {formatMessage({ id: "roster.add" })}
      </Button>
      {open && (
        <Modal
          open={open}
          title={formatMessage({ id: "roster.add" })}
          cancelText={formatMessage({ id: "cancel" })}
          onCancel={() => {
            setOpen(false);
          }}
          okButtonProps={{ hidden: true }}
          destroyOnClose
          width={800}
        >
          {children}
        </Modal>
      )}
    </>
  );
};

export default AddPlayerToRosterModal;
